/* */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { getProcessId, clearImportContactDetail } = actions;

export default (data, listDependencies = []) => {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);
  return useEffect(() => {
    if (authReducer.isLogin) {
      dispatch(getProcessId(data));
    }
    return () => {
      dispatch(clearImportContactDetail());
    };
  }, [dispatch, authReducer.isLogin, ...listDependencies]);
};
